import { Modal } from 'bootstrap';

function initializeButtons(modal: HTMLElement): void {
    const forms = modal.querySelectorAll('form');
    const footer = modal.querySelector('.modal-footer');

    if (forms.length === 0 || footer === null) {
        return;
    }

    const form: HTMLFormElement = forms.item(0);
    const buttons = Array.from(
        form.querySelectorAll<HTMLInputElement>('input[type="submit"]:not([data-move-to-footer="false"])'),
    );

    // Add "copy" of buttons to footer
    footer.prepend(
        ...buttons.map(button => {
            const newButton = document.createElement('button');
            newButton.classList.add(...button.classList);
            newButton.innerHTML = button.value;

            newButton.addEventListener('click', () => button.click());

            return newButton;
        }),
    );

    // Hide original buttons
    buttons.forEach(button => button.classList.add('d-none'));
}

export function openAjaxModals(snippet: HTMLElement): void {
    if (! snippet.classList.contains('dialog')) {
        return;
    }

    const htmlElementWithModal = snippet.querySelector('.modal') as HTMLElement | null;

    if (htmlElementWithModal === null) {
        return;
    }

    const modal = new Modal(htmlElementWithModal, { backdrop: 'static' });

    const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
            mutation.removedNodes.forEach(node => {
                if (node === htmlElementWithModal) {
                    if (modal) {
                        modal.hide();
                    }
                    observer.disconnect();
                }
            });
        });
    });

    if (htmlElementWithModal.parentNode) {
        observer.observe(snippet, { childList: true });
    }

    initializeButtons(htmlElementWithModal);

    setTimeout(() => {
        modal.show();
    }, 250);
}
